import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatTreeNestedDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { GuidanceService } from 'src/app/services/http/business/guidance/guidance.service';

@Component({
  selector: 'app-route-guide',
  templateUrl: './route-guide.component.html',
  styleUrls: ['./route-guide.component.css']
})
export class RouteGuideComponent implements OnInit {

  treeControl = new NestedTreeControl<any>(node => node.children);
  dataSource = new MatTreeNestedDataSource<any>();

  hasChild = (_: number, node: any) => node.HasChild;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RouteGuideComponent>,
    public translate: TranslateService,
    private guideService: GuidanceService,
    private errorService: ErrorsService
  ) { }

  guide: string = "";

  ngOnInit() {
    this.getGuideByUrl();
  }

  getGuideByUrl()
  {
    this.guideService.getGuideByUrl({Route: this.data.url}).subscribe({
      next: (res: any) => {
        this.guide = res.Description;
        let treeNodes = [];
        treeNodes.push(res);
        this.dataSource.data = treeNodes;
      },
      error: () => {
        this.errorService.transactionError();
      }
    })
  }


  onLoadChilds(node: any)
  {
    if(node.children != undefined)
    {
      this.treeControl.toggle(node);
      return;
    }

    this.guideService.getChildsByParentId({ParentId: node.Id}).subscribe({
      next: (res: any) => {
        this.attachChildsToNode(node,res.DataList);

        // if(isQuery)
        // {
        //   this.guidanceSearchService.onRootResolved(res.DataList);
        // }
      },
      error: () => {
        this.errorService.transactionError();
      }
    });
  }

  onNodeSelect(node: any)
  {
    this.guide = node.Description;
  }

  private attachChildsToNode(node: any,children: any[])
  {
    node.children = children;

    //trigger change detection
    const tempData = this.dataSource.data;
    this.dataSource.data = null;
    this.dataSource.data = tempData;

    this.treeControl.expand(node);
  }

  onClose()
  {
    this.dialogRef.close();
  }

}
